import React from 'react';
import BuildingsLoader from '../loaders/BuildingsLoader';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import IngestStatsLoader from '../loaders/IngestStatsLoader';
import BuildingsTable from './BuildingsTable';

import './building-mgmt.css';

const BuildingManagement = () => (
  <div className="row grid-container-lg building-mgmt">
    <BuildingsLoader />
    <OrganizationsLoader />
    <IngestStatsLoader interval="72h" />

    <div className="view">
      <BuildingsTable />
    </div>
  </div>
);

export default BuildingManagement;
